export const nameComponentObj = {
  "monitorRedisManage": {
    name: "monitorRedisManage",
    label: "系统监控/缓存列表",
    permissionIdentification: "monitor:redis:list", // 权限标识
    recycleBinIdentification: "", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "monitorModule" */"@/views/monitor/cache/list")
  },
  "monitorRedisDetail": {
    name: "monitorRedisDetail",
    label: "系统监控/缓存监控",
    permissionIdentification: "monitor:redis:detail", // 权限标识
    recycleBinIdentification: "", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "monitorModule" */"@/views/monitor/cache/index")
  },
  "monitorServerManage": {
    name: "monitorServerManage",
    label: "系统监控/服务监控",
    permissionIdentification: "monitor:server:manage", // 权限标识
    recycleBinIdentification: "", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "monitorModule" */"@/views/monitor/server/index")
  },
  "monitorScheduleManage": {
    name: "monitorScheduleManage",
    label: "系统监控/定时任务",
    permissionIdentification: "monitor:schedule:list", // 权限标识
    recycleBinIdentification: "", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "monitorModule" */"@/views/monitor/schedule/index")
  },
  "monitorOnlineManage": {
    name: "monitorOnlineManage",
    label: "系统监控/在线用户",
    permissionIdentification: "monitor:online:list", // 权限标识
    recycleBinIdentification: "", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "monitorModule" */"@/views/monitor/online/index")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  monitorScheduleCreate: {
    label: "系统监控/定时任务/新增任务",
    value: "monitor:schedule:create"
  },
  monitorScheduleDelete: {
    label: "系统监控/定时任务/删除任务",
    value: "monitor:schedule:delete"
  },
  monitorScheduleUpdate: {
    label: "系统监控/定时任务/更新任务",
    value: "monitor:schedule:update"
  },
  monitorScheduleRead: {
    label: "系统监控/定时任务/查看任务",
    value: "monitor:schedule:read"
  },
  monitorScheduleStatus: {
    label: "系统监控/定时任务/任务状态",
    value: "monitor:schedule:status"
  },
  monitorRedisDeleteALl: {
    label: "系统监控/缓存列表/清除所有缓存",
    value: "monitor:redis:deleteAll"
  },
  monitorRedisDeleteKey: {
    label: "系统监控/缓存列表/清除键名缓存",
    value: "monitor:redis:deleteKey"
  },
  monitorRedisDeleteFolder: {
    label: "系统监控/缓存列表/清除目录缓存",
    value: "monitor:redis:deleteFolder"
  },
  monitorOnlineExitUser: {
    label: "系统监控/在线用户/强退用户",
    value: "monitor:online:exitUser"
  }
}